var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"amazon-logout-button",on:{"click":_vm.$listeners.click}},[_c('span',[_vm._v(_vm._s(_vm.$t('common.amazon.logoutTop')))]),_c('span',[_vm._v(_vm._s(_vm.$t('common.amazon.logoutBottom')))])])}
var staticRenderFns = []

export { render, staticRenderFns }